<script>
  import { createEventDispatcher } from "svelte";
  import { _ as t, locale } from "svelte-i18n";

  import Input from "./Input.svelte";
  import Title from "./Title.svelte";
  import Button from "./Button.svelte";
  import { cantons } from "../src/cantons.js";
  import { isPresent } from "../src/validations.js";

  export let user;

  let name = user ? user.firstName : "";
  let surname = user ? user.lastName : "";
  let email = user ? user.email : "";
  let role = user ? user.function : "";
  let party = user ? user.party : "";
  let canton = user ? user.canton : "";

  let anchor;

  let errors = null;
  let success = false;

  $: validForm =
    isPresent(name) &&
    isPresent(surname) &&
    isPresent(email) &&
    isPresent(role);

  $: data = {
    name,
    surname,
    role,
    party,
    canton,
    lang: $locale,
  };

  const dispatch = createEventDispatcher();

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    dispatch("save", { data: data });
  };
</script>

<form
  bind:this={anchor}
  on:submit={handleSubmit}
  class="form"
  id="registration-form"
>
  <Title text={$t("myAccount")} />
  {#if success}
    <div class="success">
      <p>{$t("registration.success1")}</p>
      <p>{$t("registration.success2")}</p>
    </div>
  {:else if errors}
    <div class="errors">
      <p>{$t("registration.error1")}</p>
      <p>{$t("registration.error2")}</p>
    </div>
  {:else}
    <div class="inputs">
      <Input bind:value={name} key="name" label={$t("registration.name")} />
      <Input
        bind:value={surname}
        key="surname"
        label={$t("registration.surname")}
      />
      <Input bind:value={role} key="role" label={$t("registration.role")} />
      <Input key="party" bind:value={party} label={$t("registration.party")} />
      <Input
        bind:value={canton}
        key="canton"
        type="select"
        options={cantons}
        label={$t("registration.canton")}
      />
    </div>

    <div class="action">
      <Button type="submit" active={validForm} text={$t("registration.save")} />
    </div>
  {/if}
</form>

<style>
  .form {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
  }

  .action {
    display: flex;
    justify-content: center;
  }

  .success {
    margin: 36px 0;
    background-color: #f6f6f6;
    padding: 30px 20px;
    text-align: center;
    color: #009648;
  }

  .success p {
    font-size: 16px;
    margin: 0;
  }

  .errors {
    margin: 36px 0;
    background-color: #f6f6f6;
    padding: 30px 20px;
    text-align: center;
    color: #d23825;
  }

  .errors p {
    font-size: 16px;
    margin: 0;
  }

  @media only screen and (min-width: 600px) {
    .form {
      width: 100%;
      max-width: 700px;
      margin: 0 auto;
    }
    .inputs {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(3, 1fr);
      grid-column-gap: 20px;
      grid-row-gap: 30px;
    }

    .action {
      padding-top: 3rem;
    }
  }
</style>
